import { Container } from 'unstated';
import { getPersistentStore, getPersistentStoreMutex } from '@lemonadefashion/storage';

const KEY = 'checkout_info';
function _getStore() { return getPersistentStore(); }
function _getMutex() { return getPersistentStoreMutex(); }

function _adapt(checkoutInfo) {
  // There may exist legacy checkout info objects in storage, and this adapter ensures that we
  // have a consistent view of the data.
  const countryCodeObject = checkoutInfo.countryCodeObject || checkoutInfo.country_code_object;
  return {
    firstName: checkoutInfo.firstName || '',
    lastName: checkoutInfo.lastName || '',
    email: checkoutInfo.email || '',
    addressLine0: checkoutInfo.addressLine0 || checkoutInfo.address_line_0,
    addressLine1: checkoutInfo.addressLine1 || checkoutInfo.address_line_1,
    city: checkoutInfo.city || '',
    addressCountry: checkoutInfo.addressCountry || checkoutInfo.address_country,
    countryCodeObject: {
      dialingCode: countryCodeObject.dialingCode || countryCodeObject.dialing_code,
      countryName: countryCodeObject.countryName || countryCodeObject.country_name,
      isoAlpha2Code: countryCodeObject.isoAlpha2Code || countryCodeObject.iso_alpha_2_code
    },
    mobileNumber: checkoutInfo.mobileNumber || checkoutInfo.mobile_number
  };
}

function getCheckoutInfoFromStore() {
  try {
    const checkoutInfoJson = _getStore().getItem(KEY);
    if (checkoutInfoJson == null) return {};
    return _adapt(JSON.parse(checkoutInfoJson));
  } catch (error) {
    console.log(error);
    return {};
  }
}

function updateCheckoutInfoInStore(info) {
  return new Promise((resolve, reject) => {
    const store = _getStore();
    const mutex = _getMutex();
    mutex.lock(KEY)
      .then(() => {
        store.setItem(KEY, JSON.stringify(info));
        return mutex.release(KEY).then(resolve).catch(reject);
      })
      .catch(reject);
  });
}

class CheckoutInfoContainer extends Container {
  constructor() {
    super();
    this.state = {
      checkoutInfo: getCheckoutInfoFromStore()
    };
    window.addEventListener('storage', (e) => {
      if (e.key !== KEY) return;
      this.setState({ checkoutInfo: getCheckoutInfoFromStore() });
    });
  }

  get() {
    return this.state.checkoutInfo;
  }

  set(checkoutInfo) {
    return new Promise((resolve, reject) => {
      updateCheckoutInfoInStore(checkoutInfo)
        .catch(console.log)
        .finally(() => {
          this.setState(prevState => {
            const newCheckoutInfo = { ...prevState.checkoutInfo };
            newCheckoutInfo.firstName = checkoutInfo.firstName;
            newCheckoutInfo.lastName = checkoutInfo.lastName;
            newCheckoutInfo.email = checkoutInfo.email;
            newCheckoutInfo.addressLine0 = checkoutInfo.addressLine0;
            newCheckoutInfo.addressLine1 = checkoutInfo.addressLine1;
            newCheckoutInfo.addressCountry = checkoutInfo.addressCountry;
            newCheckoutInfo.city = checkoutInfo.city;
            newCheckoutInfo.countryCodeObject = checkoutInfo.countryCodeObject;
            newCheckoutInfo.mobileNumber = checkoutInfo.mobileNumber;
            return newCheckoutInfo;
          }, resolve);
        });
    });
  }
}

export default CheckoutInfoContainer;
